$('.product-convert-button').on('click',function(){
  var pr={
    id:$(this).parents('.product-convert').attr('data-variant'),
    quantity:1
  };
  var e=$(this);
  
  var title = $(this).parents('.product-convert').attr('data-title');
  
  $.ajax({
    url:'/cart/add.js',
    data:pr,
    dataType:'json',
    success:function(resp){
      var nrow=`
<input type="hidden" name="product_id[0]" value="11395071701">
<input type="hidden" name="variant_id[0]" value="48623017173">
<input type="hidden" name="quantity[0]" value="1">
        <tr>
          <td class="image">
            <a href="/collections/all/products/31-muscle-recovery?variant=48623017173">
            
              <img src="//cdn.shopify.com/s/files/1/2234/9717/products/post-front_cf6f656f-8e5c-4628-b494-f913e8203b04_small.jpg?v=1501567455" alt="Non GMO POST 31 Muscle Recovery - 3.98lb">
            </a>

            <p class="mobile-title"><a href="/products/31-muscle-recovery">Non GMO POST 31 Muscle Recovery - 3.98lb</a></p>

          </td>
          <td class="title">
            <p><a href="/collections/all/products/31-muscle-recovery?variant=48623017173">Non GMO POST 31 Muscle Recovery - 3.98lb</a></p>
         </td>
          <td class="quantity"><input type="text" class="field styled-input" name="updates[]" id="updates_48623017173" value="1"></td>
          <td class="total">$49.95</td>
          <td class="remove"><a title="Remove" href="/cart/change?line=1&amp;quantity=0" aria-hidden="true" class="glyph cross bold-ro-remove"></a></td>
        </tr>
		`;
//       $('.cart-table tbody').append(nrow);
      
      sessionStorage.setItem("flashAdd", title);
      
      //google analytics
      ga('send', 'event', 'Blog-cart-add', 'product-convert-add');
      
      //$('input[type=submit][name=update]')[0].click();
      window.location.href = "/cart";
    },
    error:function(err){
       console.log(err);
    }
  }); 
});